<div class="top-container">
  <app-icon *ngIf="hasIcon" class="consumption-item-icon" [name]="icon"></app-icon>
  <app-text class="consumption-item-name ellipsis" [text]="name"></app-text>
  <app-text *ngIf="hasSubtext" class="consumption-item-subtext" [text]="subtext"></app-text>
  <div class="consumption-item-value is-flex">
    <app-text [text]="value"> </app-text>
    <ng-container *ngIf="measureType">
      &nbsp;
      <app-text unit [measureType]="measureType"></app-text>
    </ng-container>
  </div>
  <app-icon *ngIf="hasArrow"
    class="consumption-item-arrow text-grey-50"
    name="chevron-right">
  </app-icon>
</div>
<div class="bottom-container">
  <app-consumption-bar *ngIf="ratios && colors; else singleBar" class="consumption-item-bar" [colors]="colors" [ratios]="ratios"></app-consumption-bar>
  <ng-template #singleBar>
    <app-consumption-bar class="consumption-item-bar" [color]="color" [percent]="ratio"></app-consumption-bar>
  </ng-template>
</div>
